import { useEffect } from "react";
import useSeatmapStore from "../../../../../../../../../stores/seatmapStore";
import { OfferTooltip } from "./OfferTooltip";
import { PriceTooltip } from "./PriceTooltip";
import { SeatTooltip } from "./SeatTooltip";

export default function TooltipWrapper({ dialogRef, tooltipState }) {
  const ARROW_SIZE = 10;
  const seatLookupTable = useSeatmapStore((state) => state.seatLookupTable);
  const sectionLookupTable = useSeatmapStore(
    (state) => state.sectionLookupTable,
  );

  const renderTooltipContent = (tooltipState) => {
    const targetIsSeat = seatLookupTable[tooltipState.targetId];
    const targetIsSection = sectionLookupTable[tooltipState.targetId];
    const isMobile = window.innerWidth <= 768;

    if (targetIsSeat) {
      if (isMobile) {
        // in the future we can look at offers length -> if more then one -> offerTooltip
        return <SeatTooltip showFullSeatTip={true} target={targetIsSeat} />;
      } else {
        return <PriceTooltip target={targetIsSeat} />;
      }
    }

    if (targetIsSection) {
      return <OfferTooltip target={targetIsSection} />;
    }
  };

  useEffect(() => {
    // Set dialog to hidden but in the dom for measurements
    if (tooltipState.targetId) {
      dialogRef.current.style.visibility = "hidden";
      dialogRef.current.style.display = "block";
      // After delay so we can make measurements
      requestAnimationFrame(() => {
        const rect = dialogRef.current.getBoundingClientRect();
        const leftPos = tooltipState.position.clientX - rect.width / 2;
        const topPos = tooltipState.position.clientY - rect.height - ARROW_SIZE;

        // set all styles at once
        dialogRef.current.style.left = `${leftPos}px`;
        dialogRef.current.style.top = `${topPos}px`;
        dialogRef.current.style.visibility = "";
        dialogRef.current.style.display = "";
        dialogRef.current.show();
      }, []);
    }
  }, [tooltipState]);

  return (
    <dialog
      ref={dialogRef}
      className={`vjx-tooltipWrapper seatmapTooltipArrow ${tooltipState.position.vertical + "--" + tooltipState.position.horizontal}`}
    >
      {renderTooltipContent(tooltipState)}
    </dialog>
  );
}
